import IMask from 'imask';

export enum PaymentAvailable {
  CreditCard = 'Cartão de Crédito',
  DebitCard = 'Cartão de Débito',
  Money = 'Dinheiro',
  PIX = 'PIX',
}

export enum PIXKeyTypes {
  CPF = 'cpf',
  CNPJ = 'cnpj',
  Email = 'email',
  Cellphone = 'celular',
  Random = 'random',
  QrCode = 'qrcode',
}

export const KEY_PIX_MASKS = {
  [PIXKeyTypes.CPF.toString()]: IMask.createMask({
    mask: '000.000.000-00',
  }),
  [PIXKeyTypes.CNPJ.toString()]: IMask.createMask({
    mask: '00.000.000/0000-00',
  }),
  [PIXKeyTypes.Cellphone.toString()]: IMask.createMask({
    mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }],
  }),
};
